export const BORDER_RADIUS = 10

// set the styles for 'hero', 'inline' or 'def' (default) form types
export const getStyleByType = (type, values) => {
  return values[type] || values['def'] || 'auto'
}
